export default class CancelUpdateProfile {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.profile.resetPending();
    this.context.stores.profile.clearErrors();
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/customer_profile/cancel_update_profile.js